module.exports = __webpack_public_path__ + "img/31.2.TN.baed62fb.png";